<template>
  <div class="relative block w-full">
    <!-- Toggle Button -->
    <div
      role="button"
      class="flex items-center w-full p-0 leading-tight transition-all rounded-lg outline-none text-start hover:bg-main-50 dark:hover:bg-gray-700 hover:bg-opacity-80 hover:text-main-900 dark:hover:text-gray-100 focus:bg-main-50 dark:focus:bg-gray-700 focus:bg-opacity-80 focus:text-main-900 dark:focus:text-gray-100 active:bg-main-50 dark:active:bg-gray-700 active:bg-opacity-80 active:text-main-900 dark:active:text-gray-100"
    >
      <button
        @click="toggleDrop"
        type="button"
        class="flex items-center justify-between w-full p-3 text-xl antialiased font-semibold leading-snug text-left transition-colors border-b-0 select-none border-b-main-100 text-main-700 dark:text-gray-300 hover:text-main-900 dark:hover:text-gray-100"
      >
        <!-- Orders Icon -->
        <div class="grid h-5 w-5 relative mr-4 place-items-center">
          <i class="fa-solid fa-receipt text-[16px]"></i>
        </div>

        <!-- Orders Text -->
        <p
          class="block mr-auto text-base antialiased font-normal leading-relaxed text-main-900 dark:text-gray-200"
        >
          Orders
        </p>

        <!-- Chevron Icon -->
        <i
          :class="{ 'rotate-90': isOpen }"
          class="fa-solid fa-chevron-right text-[12px] ml-4 transition-transform duration-300"
        ></i>
      </button>
    </div>

    <!-- Dropdown Content -->
    <div
      v-show="isOpen"
      class="overflow-hidden transition-all duration-300 ease-in-out"
    >
      <div
        class="block w-full py-1 text-sm antialiased font-light leading-normal text-gray-700 dark:text-gray-300"
      >
        <nav
          class="flex min-w-[240px] flex-col gap-1 p-0 text-base font-normal text-main-700 dark:text-gray-300"
        >
          <!-- Recent Orders Link -->
          <router-link
            active-class="bg-main-50 dark:bg-gray-700 bg-opacity-80 rounded-lg"
            to="/recent-orders"
            role="button"
            class="flex items-center w-full p-3 leading-tight transition-all rounded-lg outline-none text-start hover:bg-main-50 dark:hover:bg-gray-700 hover:bg-opacity-80 hover:text-main-900 dark:hover:text-gray-100 focus:bg-main-50 dark:focus:bg-gray-700 focus:bg-opacity-80 focus:text-main-900 dark:focus:text-gray-100 active:bg-main-50 dark:active:bg-gray-700 active:bg-opacity-80 active:text-main-900 dark:active:text-gray-100"
          >
            <div class="grid mr-4 place-items-center w-5 h-3">
              <i class="fa-solid fa-chevron-right text-[12px]"></i>
            </div>
            Recent Orders
          </router-link>

          <!-- Order History Link -->
          <router-link
            to="/order-history"
            active-class="bg-main-50 dark:bg-gray-700 bg-opacity-80 rounded-lg"
            role="button"
            class="flex items-center w-full p-3 leading-tight transition-all rounded-lg outline-none text-start hover:bg-main-50 dark:hover:bg-gray-700 hover:bg-opacity-80 hover:text-main-900 dark:hover:text-gray-100 focus:bg-main-50 dark:focus:bg-gray-700 focus:bg-opacity-80 focus:text-main-900 dark:focus:text-gray-100 active:bg-main-50 dark:active:bg-gray-700 active:bg-opacity-80 active:text-main-900 dark:active:text-gray-100"
          >
            <div class="grid mr-4 place-items-center w-5 h-3">
              <i class="fa-solid fa-chevron-right text-[12px]"></i>
            </div>
            Order History
          </router-link>

          <!-- Customers Link -->
          <router-link
            to="/customers"
            active-class="bg-main-50 dark:bg-gray-700 bg-opacity-80 rounded-lg"
            role="button"
            class="flex items-center w-full p-3 leading-tight transition-all rounded-lg outline-none text-start hover:bg-main-50 dark:hover:bg-gray-700 hover:bg-opacity-80 hover:text-main-900 dark:hover:text-gray-100 focus:bg-main-50 dark:focus:bg-gray-700 focus:bg-opacity-80 focus:text-main-900 dark:focus:text-gray-100 active:bg-main-50 dark:active:bg-gray-700 active:bg-opacity-80 active:text-main-900 dark:active:text-gray-100"
          >
            <div class="grid mr-4 place-items-center w-5 h-3">
              <i class="fa-solid fa-chevron-right text-[12px]"></i>
            </div>
            Customers
          </router-link>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrdersComponent",
  data() {
    return { isOpen: false };
  },
  methods: {
    toggleDrop() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
